import { useRef } from 'react';
import { useChannel } from 'ably/react';
import { useAppDispatch } from '@/app/hooks';
import { stageInviteEventReceived } from '@/features/live/liveSlice';
import { createLiveEventDeduplicator, normalizeLiveBatchMessage } from '@/lib/liveEventBatch';
import { readInviteRequestEvent } from '@/lib/inviteRequestState';

/**
 * Arme et désarme les attentes d'invitation à la scène depuis le canal Ably, au niveau de la page :
 * le panneau intervenants est démonté quand il est replié, l'abonnement doit lui survivre.
 * Présentateur et modérateur partagent le canal : l'attente posée par l'un s'affiche chez l'autre.
 * À appeler une seule fois, dans AdminLivePage (qui rend aussi ModeratorLivePage).
 */
export function useStageInviteEvents(channelName: string | null | undefined) {
  const dispatch = useAppDispatch();
  const deduplicatorRef = useRef(createLiveEventDeduplicator());

  useChannel(channelName ?? '', (message) => {
    if (!channelName) return;
    for (const currentMessage of normalizeLiveBatchMessage(message)) {
      if (currentMessage.name !== 'live-event') continue;
      if (!deduplicatorRef.current.shouldProcess(currentMessage.eventId)) continue;
      const event = readInviteRequestEvent(currentMessage.data);
      if (event) {
        dispatch(stageInviteEventReceived(event));
      }
    }
  });
}
